





























































import SeletorDeTabelaDePreco from '@/components/tabeladepreco/SeletorDeTabelaDePreco.vue'
import { TabelaDePreco } from '@/models'
import { Vue, Component, Ref, Prop } from 'vue-property-decorator'

@Component({
	components: {
		SeletorDeTabelaDePreco,
	},
})
export default class DialogoDeSelecionarTabelaDePreco extends Vue {
	@Ref() form!: HTMLFormElement
	@Prop({ type: String, default: null }) lojaId!: string | null
	@Prop({ type: Boolean, default: false }) seletorDesabilitado!: boolean
	@Prop({ type: Boolean, default: false }) recalculaItensDoCaixa!: boolean

	mostra = false
	tabelaDePrecoSelecionada: TabelaDePreco | null = null
	aplicando = false

	get itensAdicionais(): TabelaDePreco[] {
		return this.tabelaDePrecoSelecionada ? [this.tabelaDePrecoSelecionada] : []
	}

	mostrar(tabelaAtual?: TabelaDePreco | null) {
		this.mostra = true
		this.tabelaDePrecoSelecionada = tabelaAtual || null
	}

	fechar() {
		this.mostra = false
		this.tabelaDePrecoSelecionada = null
	}

	async aplicarTabela() {
		this.aplicando = true
		try {
			this.$emit('aplicarTabela', this.tabelaDePrecoSelecionada)
			this.fechar()
		} catch (error) {
			// Erro será tratado pelo componente pai
		} finally {
			this.aplicando = false
		}
	}
}
